import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler } from '@angular/common/http';
import { CurrentTabPageStorageWrapper } from '../classes/current-tabpage-storage-wrapper.class';

@Injectable()
export class SignalRHeaderInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler) {
        if (req.url.indexOf('publicapi') >= 0 || req.url.indexOf('adminapi') >= 0) {
            const authReq = req.clone({
                headers: req.headers.set('SignalRChannelId', CurrentTabPageStorageWrapper.signalRChannelId),
            });
            return next.handle(authReq);
        }
        return next.handle(req);
    }
}
